import { react2angular } from 'react2angular';
import QuestionSortable from './QuestionSortable';

angular
  .module('bb.appointments.feedback')
  .component(
    'bbQuestionSortable',
    react2angular(
      QuestionSortable,
      ['question', 'remove', 'index', 'edit', 'isPreview', 'notEditable'],
      ['ModalService'],
    ),
  );
